import Image from 'next/image';
import {
  Container,
  Description,
  Image as ImageWrapper,
  Section,
  Subtitle,
  TextWrapper,
  Title,
} from './sectionDescriptionWithImage.styles';
import { ISectionDescriptionWithImageProps } from './sectionDescriptionWithImage.models';
import { imageSerializer } from '../../../utils/imageSerializer';
import { useRef } from 'react';

export const SectionDescriptionWithImage = ({
  title,
  description,
  image,
  subtitle,
  isImageToRight = false,
  titleAs,
}: ISectionDescriptionWithImageProps) => {
  const sectionRef = useRef<HTMLElement>(null);

  return (
    <Section ref={sectionRef}>
      <Container>
        <TextWrapper>
          <Title as={titleAs}>{title}</Title>
          <Subtitle as={titleAs}>{subtitle}</Subtitle>
          <Description>{description}</Description>
        </TextWrapper>
        <ImageWrapper isImageToRight={isImageToRight}>
          <Image {...imageSerializer(image, { layout: 'fill' })} />
        </ImageWrapper>
      </Container>
    </Section>
  );
};
